import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that scrolls to top when route changes
 * Handles both regular routes and hash navigation
 *
 * @returns {null} This component doesn't render anything
 */
function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // If there's a hash, try to scroll to that element after a small delay
      // to ensure the page has rendered
      setTimeout(() => {
        const id = location.hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          const offset = 84; // Header height
          const top =
            element.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }, 100);
    } else {
      // No hash, scroll to top immediately
      window.scrollTo(0, 0);
    }
  }, [location]); // Listen to full location changes

  return null;
}

export default ScrollToTop;
